import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Product from "./pages/Product";
import Customer from "./pages/Customer";
import Supplier from "./pages/Supplier";
import Sale from "./pages/Sale";
import Purchase from "./pages/Purchase";
import Firm from "./pages/Firm";
import PrintSettings from "./pages/PrintSettings";
import PrintSale from "./pages/PrintSale";
import StockReport from "./pages/StockReport";
import ProtectedRoute from "./ProtectedRoute";


const ComingSoon = ({ title }) => {
  const AppLayout = require("./AppLayout").default;

  return (
    <AppLayout title={title} subtitle="Module under development">
      <div className="form-card">
        <div className="form-card-body">
          <h2>{title}</h2>
          <p style={{ marginTop: "8px", color: "#64748b" }}>
            This module will be added next.
          </p>
        </div>
      </div>
    </AppLayout>
  );
};

function App() {
  const comingSoonRoutes = [
    ["/master/roles", "Role Management"],
    ["/master/users", "User Management"],
    ["/accounts/supplier", "Supplier Master"],
    ["/reports/sale", "Sale Report"],
    ["/reports/purchase", "Purchase Report"],
  ];

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/master/firm"
          element={
            <ProtectedRoute>
              <Firm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/master/print-settings"
          element={
            <ProtectedRoute>
              <PrintSettings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/master/product"
          element={
            <ProtectedRoute>
              <Product />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounts/customer"
          element={
            <ProtectedRoute>
              <Customer />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accounts/supplier"
          element={
            <ProtectedRoute>
              <Supplier />
            </ProtectedRoute>
          }
        />

        <Route
          path="/transaction/sale"
          element={
            <ProtectedRoute>
              <Sale />
            </ProtectedRoute>
          }
        />

        <Route
          path="/transaction/purchase"
          element={
            <ProtectedRoute>
              <Purchase />
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports/stock"
          element={
            <ProtectedRoute>
              <StockReport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/print-sale/:id"
          element={
            <ProtectedRoute>
              <PrintSale />
            </ProtectedRoute>
          }
        />

        {comingSoonRoutes.map(([path, title]) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute>
                <ComingSoon title={title} />
              </ProtectedRoute>
            }
          />
        ))}

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;